/**
 * @generated SignedSource<<1d4d39c3af0fe3c5bdf15ad33b3fb9bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelType = "COMPOSITE" | "CRUSTAL" | "SUBDUCTION" | "%future added value";
export type TableType = "GENERAL" | "HAZARD_GRIDDED" | "HAZARD_SITES" | "MFD_CURVES" | "MFD_CURVES_V2" | "%future added value";
export type InversionSolutionDiagnosticContainerQuery$variables = {
  ids?: ReadonlyArray<string> | null | undefined;
};
export type InversionSolutionDiagnosticContainerQuery$data = {
  readonly nodes: {
    readonly result: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly created?: any | null | undefined;
          readonly file_name?: string | null | undefined;
          readonly file_size?: any | null | undefined;
          readonly file_url?: string | null | undefined;
          readonly id?: string;
          readonly md5_digest?: string | null | undefined;
          readonly meta?: ReadonlyArray<{
            readonly k: string | null | undefined;
            readonly v: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly mfd_table?: {
            readonly id: string;
          } | null | undefined;
          readonly mfd_table_id?: string | null | undefined;
          readonly produced_by?: {
            readonly __typename: string;
            readonly id?: string;
            readonly parents?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly parent: {
                    readonly __typename: "GeneralTask";
                    readonly argument_lists: ReadonlyArray<{
                      readonly k: string | null | undefined;
                      readonly v: ReadonlyArray<string | null | undefined> | null | undefined;
                    } | null | undefined> | null | undefined;
                    readonly created: any | null | undefined;
                    readonly description: string | null | undefined;
                    readonly id: string;
                    readonly meta: ReadonlyArray<{
                      readonly k: string | null | undefined;
                      readonly v: string | null | undefined;
                    } | null | undefined> | null | undefined;
                    readonly model_type: ModelType | null | undefined;
                    readonly notes: string | null | undefined;
                    readonly swept_arguments: ReadonlyArray<string | null | undefined> | null | undefined;
                    readonly title: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined>;
            } | null | undefined;
          } | null | undefined;
          readonly relations?: {
            readonly total_count: number | null | undefined;
          } | null | undefined;
          readonly tables?: ReadonlyArray<{
            readonly table_id: string | null | undefined;
            readonly table_type: TableType | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
};
export type InversionSolutionDiagnosticContainerQuery = {
  response: InversionSolutionDiagnosticContainerQuery$data;
  variables: InversionSolutionDiagnosticContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id_in",
    "variableName": "ids"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "k",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "v",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyValuePair",
  "kind": "LinkedField",
  "name": "meta",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "file_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "file_url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "file_size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "md5_digest",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FileRelationConnection",
      "kind": "LinkedField",
      "name": "relations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FileInterface",
  "abstractKey": "__isFileInterface"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Table",
  "kind": "LinkedField",
  "name": "mfd_table",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mfd_table_id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "LabelledTableRelation",
  "kind": "LinkedField",
  "name": "tables",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "table_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "table_type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model_type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "swept_arguments",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyValueListPair",
  "kind": "LinkedField",
  "name": "argument_lists",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InversionSolutionDiagnosticContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NodeFilter",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchResultConnection",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "produced_by",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskTaskRelationConnection",
                                    "kind": "LinkedField",
                                    "name": "parents",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskTaskRelationEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskTaskRelation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "GeneralTask",
                                                "kind": "LinkedField",
                                                "name": "parent",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v3/*: any*/),
                                                  (v7/*: any*/),
                                                  (v13/*: any*/),
                                                  (v14/*: any*/),
                                                  (v15/*: any*/),
                                                  (v9/*: any*/),
                                                  (v16/*: any*/),
                                                  (v17/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "AutomationTaskInterface",
                                "abstractKey": "__isAutomationTaskInterface"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "InversionSolutionInterface",
                        "abstractKey": "__isInversionSolutionInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InversionSolutionDiagnosticContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NodeFilter",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchResultConnection",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "produced_by",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskTaskRelationConnection",
                                    "kind": "LinkedField",
                                    "name": "parents",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskTaskRelationEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskTaskRelation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "GeneralTask",
                                                "kind": "LinkedField",
                                                "name": "parent",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v3/*: any*/),
                                                  (v7/*: any*/),
                                                  (v13/*: any*/),
                                                  (v14/*: any*/),
                                                  (v15/*: any*/),
                                                  (v9/*: any*/),
                                                  (v16/*: any*/),
                                                  (v17/*: any*/),
                                                  (v18/*: any*/),
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isNode"
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "AutomationTaskInterface",
                                "abstractKey": "__isAutomationTaskInterface"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "InversionSolutionInterface",
                        "abstractKey": "__isInversionSolutionInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9693d8045eb78b690da375b7c9efbfd5",
    "id": null,
    "metadata": {},
    "name": "InversionSolutionDiagnosticContainerQuery",
    "operationKind": "query",
    "text": "query InversionSolutionDiagnosticContainerQuery(\n  $ids: [ID!]\n) {\n  nodes(id_in: $ids) {\n    result {\n      edges {\n        node {\n          __typename\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on FileInterface {\n            __isFileInterface: __typename\n            file_name\n            file_url\n            file_size\n            md5_digest\n            meta {\n              k\n              v\n            }\n            relations {\n              total_count\n            }\n          }\n          ... on InversionSolutionInterface {\n            __isInversionSolutionInterface: __typename\n            created\n            mfd_table {\n              id\n            }\n            mfd_table_id\n            tables {\n              table_id\n              table_type\n            }\n            produced_by {\n              __typename\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on AutomationTaskInterface {\n                __isAutomationTaskInterface: __typename\n                parents {\n                  edges {\n                    node {\n                      parent {\n                        __typename\n                        id\n                        meta {\n                          k\n                          v\n                        }\n                        ... on Node {\n                          __isNode: __typename\n                          id\n                        }\n                        title\n                        notes\n                        description\n                        created\n                        model_type\n                        swept_arguments\n                        argument_lists {\n                          k\n                          v\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "120911214a99d55d92db7d06c2bd63f3";

export default node;
